/* -------------------- SIMPLE MAPPER RENDERER ----------------------- */
console.log('[FE_c] V 1.0.1');
import { FE$DataConverter, FEngineException } from './v2-fgen-fengine.js'
function FE$SimpleMapperDConverter() { }
FE$SimpleMapperDConverter.prototype = new FE$DataConverter();
FE$SimpleMapperDConverter.prototype.getType = function () {
   return 'map';
}
FE$SimpleMapperDConverter.prototype._copycat = function (values, ret) {
   var indata = []
   var outdata = []
   indata.push(values)
   outdata.push(ret)
   while (indata.length > 0) {
      var currIn = indata.pop();
      var currOut = outdata.pop();
      for (var i in currIn) {
         console.log('[CDC]Copycat Working with ' + i)
         // Missing null condition and boolean
         if (typeof currIn[i] === 'string' || typeof currIn[i] === 'number' || typeof currIn[i] === 'boolean' || currIn[i] == null) {
            currOut[i] = currIn[i]
         } else if (Array.isArray(currIn[i])) {
            console.log('[CDC]Copycat Converting array');
            currOut[i] = new Array();
            for (var j = 0; j < currIn[i].length; j++) {
               if (typeof currIn[i][j] == 'string' || typeof currIn[i][j] === 'number' || currIn[i][j] == null) {
                  console.log('[CDC]Copycat Inserting ' + currIn[i][j] + ' on array ' + currOut[i]);
                  currOut[i].push(currIn[i][j]);
               } else {
                  console.log('[CDC]Copycat Handling object ' + currIn[i][j] + ' on array ' + currOut[i]);
                  var obj = {};
                  currOut[i].push(obj);
                  indata.push(currIn[i][j]);
                  outdata.push(obj);
               }
            }
         } else if (typeof currIn[i] === 'object') {
            console.log('Have to copy property ' + i + ' as object with value ' + JSON.stringify(currIn[i]));
            currOut[i] = {}
            indata.push(currIn[i]);
            outdata.push(currOut[i])
         }
      }
   }
   return ret
}
FE$SimpleMapperDConverter.prototype._map = function (values, ret, mapping) {
   console.log('Interpreting mapping: ' + JSON.stringify(mapping))
   for (var i in mapping) {
      console.log('Handling: ' + i)
      var valueKey = mapping[i]
      var value = null;
      if (typeof valueKey == 'object') {
         // Mapping to an object
         value = {}
         this._map(values, value, mapping[i]);

      } else if (valueKey.indexOf("'") == 0) {
         value = valueKey.substring(1, valueKey.length - 1)
      } else {
         value = values[valueKey]
      }
      ret[i] = value;
   }
}
FE$SimpleMapperDConverter.prototype.convert = function (values, configuration) {
   var ret = null
   if (configuration.copycat === true) {
      ret = this._copycat(values, {});
   } else {
      ret = {}
   }

   if (configuration.mapping) {
      this._map(values, ret, configuration.mapping)
   }
   return ret
}
/* -------------------- DATE CONVERTER ----------------------- */
function FE$DateDConverter() { }
FE$DateDConverter.prototype = new FE$DataConverter();
FE$DateDConverter.prototype.getType = function () {
   return 'date';
}

FE$DateDConverter.prototype._convertSingle = function (input) {
   var aDate = input.split('/');
   if (aDate.length != 3) {
      throw new FEngineException('Wrong value found. Validators not in place?');
   }
   return aDate[2] + '-' + aDate[1] + '-' + aDate[0];
}
FE$DateDConverter.prototype.convert = function (values, configuration) {
   if (!configuration.fields || !Array.isArray(configuration.fields)) {
      throw new FEngineException('Wrong configuration for date converter');
   }
   for (var i = 0; i < configuration.fields.length; i++) {
      var key = configuration.fields[i];
      var value = values[key];
      if (value) {
         values[key] = this._convertSingle(value);
      }
   }
   return values;
}

/* -------------------- INTO OBJECT MAPPER RENDERER (MAPPER EXTENSION) ----------------------- */
function FE$IntoObjectMapperDConverter() { }
FE$IntoObjectMapperDConverter.prototype = new FE$SimpleMapperDConverter();
FE$IntoObjectMapperDConverter.prototype.getType = function () {
   return 'mapInto';
}

FE$IntoObjectMapperDConverter.prototype.convert = function (values, configuration) {

   if (!("targetKey" in configuration)) {
      throw new FEngineException('No targetKey found in configuration for data converter: ' + JSON.stringify(configuration))
   }
   var array = ('array' in configuration ? configuration.array : false);
   var target = null;
   var targetKey = configuration.targetKey
   if (array) {
      if (!values[targetKey] || !Array.isArray(values[targetKey])) {
         values[targetKey] = new Array();
      }
      target = {}
      values[targetKey].push(target)
   } else {
      if (!target) {
         target = {}
         values[targetKey] = target;
      }
   }

   if (configuration.copycat === true) {
      this._copycat(values, target);
   }

   if (configuration.mapping) {
      this._map(values, target, configuration.mapping)
   }
   return values;
}

/* ---- REGISTRATIONS ---- */
fe$ngine.register(FE$SimpleMapperDConverter);
fe$ngine.register(FE$DateDConverter);
fe$ngine.register(FE$IntoObjectMapperDConverter);